module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/010-c83ce314dbb960d68f89a00388813253.jpg";